import { defineMessages } from 'react-intl'

import { ORDER_TYPE } from 'features/Inventories/components/OrderType/constants'
import { REMOVE_ITEMS_TYPE } from './constants'

export const removeItemsTypeMessages = defineMessages({
  [REMOVE_ITEMS_TYPE.WASTE]: {
    id: 'spanish.dictionary.waste',
    defaultMessage: 'Merma'
  },
  [ORDER_TYPE.SHIPMENT]: {
    id: 'spanish.dictionary.shipment',
    defaultMessage: 'Envío'
  }
})
